jQuery(function($){
	$('.purchase-button.arrangement a.arrangement-request').on('click', function(e){
		e.preventDefault();

		if(!$(this).closest('.purchase-button').hasClass('check-voicing')) {
			$('.popup-cart').removeClass('showing');

			const voicing = $(this).attr('voicing');
			const voicingTitle = $(this).attr('voicing_title');
			const songTitle = decodeURIComponent(atob($(this).attr('song_title')));
			const songId = $(this).attr('song_id');

			const modalWrapper = $('#arrangement-request-modal-wrapper');

			if($('.store-layout-overlay.visible').length) $('.store-layout-overlay').removeClass('visible');
			if($('.store-item.showing').length) $('.store-item').removeClass('showing');
			if($('.more-info-trigger.showing').length) $('.more-info-trigger').removeClass('showing');

			modalWrapper.find('.arrangement-modal-song-title span.song-title').html(songTitle);
			modalWrapper.find('.arrangement-modal-voicing span.voicing-title').html(voicingTitle);

			modalWrapper.find('.arrangement-modal-body input[name="song_id"]').val(songId);
			modalWrapper.find('.arrangement-modal-body input[name="voicing"]').val(voicing);
			modalWrapper.find('.arrangement-modal-body input[name="voicing_title"]').val(voicingTitle);

			modalWrapper.find('.arrangement-modal input[type="submit"]').show();
			if(modalWrapper.find('.arrangement-modal .loading-arrangement-modal').length) {
				modalWrapper.find('.arrangement-modal .loading-arrangement-modal').hide();
			}

			modalWrapper.find('.arrangement-modal-background').addClass('visible');
			modalWrapper.find('.arrangement-modal').addClass('showing');


			console.log(voicing, voicingTitle, songTitle, songId);
		}
	});

	$('form.arrangement-request-form').on('submit', function(e){
		const el = $(this);

	    let isFormValid = el[0].checkValidity();
	    if(!isFormValid) {
	        el[0].reportValidity();
	        return;
	    }

		e.preventDefault();

		console.log(el);
		console.log(el.serializeArray());

		data = {};
		$.each(el.serializeArray(), function(i, field){
			data[field.name] = field.value;
		});

		console.log(data);

		el.find('input[type="submit"]').hide().after('<div class="loading-arrangement-modal"><span class="fas fa-cog fa-spin"></span> Sending Request</div>');

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
			el.find('.loading-arrangement-modal').html('<div class="alert success" style="margin: 0"><p>' + response + '</p></div>');
		});
	});
});